import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const AuthGuard: CanActivateFn = (route, state) => {
  console.log( '================= AuthGuard' + route + ',' + state );
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  if( authService.isAuthenticatedUser() ){
    return true;
  } else {
    return router.createUrlTree(['/login']);
  }
};
